import "bootstrap/dist/css/bootstrap.min.css";
import { lazy, Suspense } from "react";
import "react-modern-drawer/dist/index.css";
import { BrowserRouter, Route, Routes, Navigate } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-quill/dist/quill.snow.css";
import { Loader } from "./Components/atoms/Loader";
import Blogs from "./pages/Blogs";
import BlogDetail from "./pages/BlogsDetailPage";
import Locations from "./pages/Locations";
import BeforeLoginRoute from "./resources/utils/unauthorizedRouterWrapper";
import ProtectedRouter from "./resources/utils/authorizedRouterWrapper";
import "./assets/css/color.css";
import "./assets/css/globals.css";
import "./assets/css/typography.css";
import ContactRequests from "./pages/ContactRequests";
import Newsletter from "./pages/Newsletter";

//tt
const Dashboard = lazy(() => import("./pages/Dashboard"));
const Notifications = lazy(() => import("./pages/Notifications"));
const Users = lazy(() => import("./pages/Users"));
const Orders = lazy(() => import("./pages/Orders"));
const Profile = lazy(() => import("./pages/Profile"));
const CMSPage = lazy(() => import("./pages/CMSPage"));
const CMSDetailPage = lazy(() => import("./pages/CMSDetailPage"));

const Vendors = lazy(() => import("./pages/Vendors"));
const ChefPlanners = lazy(() => import("./pages/ChefPlanners"));
const Categories = lazy(() => import("./pages/Categories"));

// const { accessToken } = useSelector((state) => state?.authReducer);
const LoginPage = lazy(() => import("./pages/LoginPage"));
const ForgotPasswordPage = lazy(() => import("./pages/ForgotPasswordPage"));

function App() {
  return (
    <>
      <ToastContainer />
      <BrowserRouter>
        <Suspense fallback={<Loader className="mvh-100" />}>
          <Routes>
            <Route
              path="/"
              exact
              element={<BeforeLoginRoute element={<LoginPage />} />}
            />
            <Route
              path="/forgot-password"
              exact
              element={<BeforeLoginRoute element={<ForgotPasswordPage />} />}
            />
            <Route
              path="/dashboard"
              exact
              element={<Navigate replace to="/cms" />}
            />
            <Route
              path="/notification"
              exact
              element={<ProtectedRouter element={<Notifications />} />}
            />
            <Route
              path="/users"
              element={<ProtectedRouter element={<Users />} />}
            />
            <Route
              path="/blogs"
              element={<ProtectedRouter element={<Blogs />} />}
            />
            <Route
              path="/blogs/:slug"
              element={<ProtectedRouter element={<BlogDetail />} />}
            />
            <Route
              path="/categories"
              element={<ProtectedRouter element={<Categories />} />}
            />
            <Route
              path="/locations"
              element={<ProtectedRouter element={<Locations />} />}
            />
            <Route
              path="/orders"
              element={<ProtectedRouter element={<Orders />} />}
            />
            <Route
              path="/profile-setting"
              element={<ProtectedRouter element={<Profile />} />}
            />
            <Route
              path="/contact-requests"
              element={<ProtectedRouter element={<ContactRequests />} />}
            />
            <Route
              path="/newsletter"
              element={<ProtectedRouter element={<Newsletter />} />}
            />
            <Route
              path="/chef-planners"
              element={<ProtectedRouter element={<ChefPlanners />} />}
            />
            <Route
              path="/cms"
              element={<ProtectedRouter element={<CMSPage />} />}
            />
            <Route
              path={`/cms/:pageName`}
              element={<ProtectedRouter element={<CMSDetailPage />} />}
            />
            <Route path="/vendors" element={<Vendors />} />
          </Routes>
        </Suspense>
      </BrowserRouter>
    </>
  );
}

export default App;
